const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.variantCarousel = this.setupVariantCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els['quick-buy']?.exists) {
      this.handleQuickBuy = this.handleQuickBuy.bind(this)

      this.listeners.add(
        this.els['quick-buy'].element,
        'click',
        this.handleQuickBuy,
      )
    }

    if (this.els.swatch?.exists) {
      this.handleSwatchEnter = this.handleSwatchEnter.bind(this)
      this.handleSwatchLeave = this.handleSwatchLeave.bind(this)

      this.els.swatch.elements.forEach((swatch) => {
        this.listeners.add(swatch, 'mouseenter', this.handleSwatchEnter)
        this.listeners.add(swatch, 'mouseleave', this.handleSwatchLeave)
      })
    }
  }

  setupVariantCarousel () {
    if (!this.els.slides?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 'auto',
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  handleSwatchEnter (event) {
    this.replaceMediaFromSwatch(event.currentTarget)
  }

  handleSwatchLeave () {
    const currentSwatch = this.querySelector(
      '[data-product-card-current-swatch]',
    )

    if (!currentSwatch) return

    this.replaceMediaFromSwatch(currentSwatch)
  }

  replaceMediaFromSwatch (swatch) {
    const templateMedia = swatch.querySelector('template[data-role="media"]')
    const templateMediaHover = swatch.querySelector(
      'template[data-role="media-hover"]',
    )

    if (this.els.media?.exists && templateMedia?.innerHTML?.trim()) {
      this.els.media.element.innerHTML = templateMedia.innerHTML
    }

    if (this.els['media-hover']?.exists) {
      this.els['media-hover'].element.innerHTML =
        templateMediaHover?.innerHTML?.trim() || ''
    }
  }

  async handleQuickBuy () {
    await window.BAO.sectionRenderer
      .fetchSingle(
        'quick-buy',
        this.els['quick-buy'].element.dataset.productUrl,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.sec-QuickBuy')

        this.externalEls['quick-buy'].element.innerHTML = bodyContent.outerHTML

        window.drawers.activeDrawerKey = 'quick-buy'
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }
}

customElements.define('product-card', ProductCard, { extends: 'article' })
